"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconList = exports.iconMap = void 0;
exports.iconMap = {
    // Edition
    'add': 'md-add',
    'delete': 'md-delete',
    'edit': 'md-edit',
    'help': 'md-help-outline',
    // In game
    'gamepad': 'md-videogame-asset',
    'playCircle': 'md-play-circle-outline',
    'play': 'io-play',
    'home': 'md-home',
    'restart': 'md-restart-alt',
    'back': 'md-arrow-back-ios',
    'return': 'md-keyboard-return',
    'next': 'md-next-plan',
    'pause': 'md-pause',
    'press': 'fa-hand-pointer',
    // System
    'settings': 'md-settings',
    'search': 'md-search',
    'volumeOn': 'md-volume-up',
    'volumeOff': 'md-volume-off',
    'fullscreenOn': 'md-fullscreen',
    'fullscreenOff': 'md-fullscreen-exit',
    'favoriteOn': 'md-favorite',
    'favoriteOff': 'md-favorite-border',
    'qrcode': 'md-qr-code',
    'addPlayer': 'md-person-add-alt',
    'screenRotation': 'md-screen-rotation',
    'people': 'md-group',
    'time': 'md-watch-later',
    'error': 'md-error',
    // Other
    'emoji': 'md-emoji-emotions',
    'discord': 'fa-discord',
};
exports.iconList = Object.keys(exports.iconMap);
//# sourceMappingURL=icon_list.js.map